import React, { useState } from 'react';

import './accordion.scss';

export default function Accordion(props) {
  const [show, setShow] = useState({ 0: true });

  const getAutomationId = (automationIdSuffix) =>
    `${props.automationIdPrefix}_${automationIdSuffix}`;

  return (
    <div className="Accordion" automationid={getAutomationId('Accordion_Main')}>
      {props.elements.map((element, index) => (
        <div
          className="element"
          key={index}
          automationid={getAutomationId(
            `Accordion_Child_${index}_${element.automationIdDescription}`,
          )}
        >
          <div
            automationid={getAutomationId(
              `Accordion_Child_${index}_${element.automationIdDescription}_Div_Button_Show_Content`,
            )}
            className={`accordion-heading  ${show[index] ? 'expanded' : ''}`}
            onClick={() => {
              var showNew = { ...show };
              showNew[index] = !showNew[index];
              for (var key in showNew) {
                if (key != index) {
                  showNew[key] = false;
                }
              }
              setShow(showNew);
            }}
          >
            {element.title}

            <span className="is-pulled-right">
              {show[index] && typeof element.onEdit == 'function' && !element.hideEdit && (
                <span
                  className={`edit-button-accordion`}
                  onClick={() => {
                    element.onEdit();
                  }}
                />
              )}
              <span className={`chevron-button ${show[index] ? 'expanded' : ''}`} />
            </span>

            <div className="bottom-shadow-accordion"></div>
          </div>
          {show[index] && <div className="separator-bar" />}
          {show[index] && (
            <div className={element.componentContainerClass}>{element.component}</div>
          )}
        </div>
      ))}
    </div>
  );
}
